import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Grid } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import HomeProductCard from './HomeProductCard';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import Slider from 'react-slick';
import productCardsContainerStyles from '../../styles/Home/ProductCardContainer';
import SnackBarAlert from "../../components/Alerts/AlertComponent";
import { resetMessage } from '../../flux/actions/shoppingCart-actions';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../styles/slick.scss"

import { ProductModel } from '../../models/product-model';

interface Props {
    title: string;
    products: ProductModel[];
    loading?: boolean;
}

const ProductCardsSkeleton = (props: { quantity: number }) => {
    return (
        <Grid 
            container
            spacing={10}
            style={{ marginTop: '1rem' }}
            >
                {
                    [...Array(props.quantity)].map((_: number) => (
                        <Grid item md={4}>
                            <Skeleton variant='rect' width='100%' height={400} />
                            <Skeleton width='100%' />
                            <Skeleton width='60%' />
                        </Grid>
                    ))
                }
        </Grid>
    );
}

const ProductCardsContainer: FC<Props> = (props: Props) => {
    const classes = productCardsContainerStyles();
    const { width } = useWindowDimensions();
    const settings = {
        className: "center",
        centerMode: width > 500 ? true : false,
        dots: true,
        infinite: true,
        centerPadding: '225px',
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 2,
                    centerPadding: '280px'
                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerPadding: '180px'
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true
                }
            }
        ]
    }

    const dispatcher = useDispatch();
    const cart = useSelector((state: any) => state.cart);
    const { isProductAdded, isProductInCart } = cart;

    const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === "clickaway") {
            return;
        }
        dispatcher(resetMessage());
    }

    useEffect(() => {
        dispatcher(resetMessage());
    }, [dispatcher]);


    return (
        <Container style={{ paddingLeft: '26px', paddingRight: '26px' }}>
            {isProductAdded && <SnackBarAlert severity='success' message='Se ha agregado un producto al carrito' open={isProductAdded}/>}
            {isProductInCart && <SnackBarAlert severity='info' message='Este producto ya fue agregado, modifica la cantidad en tu carrito!' open={isProductInCart} onClose={handleClose}/>}
            <div className={classes.titlesSection}>
                <h1>{props.title}</h1>
                <span>Contamos con servicio a domicilio</span>
            </div>
            {
                props.loading 
                    ? <ProductCardsSkeleton quantity={3} />
                    : <div className={classes.cardsCarousel}>
                        <Slider {...settings}>
                            {
                                props.products.map((item: any, i: number) => (
                                    <HomeProductCard key={i} product={item} />
                                ))
                            }
                        </Slider>
                    </div>
            }
        </Container>
    )
}

export default ProductCardsContainer;
